// Module
var code = `<div class="flexible_container flex_center_aligned tw:gap-0.5">
    <label class="hidden" data-bind="text: translated('Sub generation'),
                      attr: {for: 'sub_generation_1' + (idSuffix !== undefined ? '_' + idSuffix : '')}"></label>
    <select class="width_full" data-bind="css: {invalid_data: subGeneration1.isInvalid},
                       options: pyratFrontend.session.pyratConf.GEN_SETS.subgen,
                       optionsCaption: translated('None2'),
                       value: subGeneration1,
                       attr: {id: 'sub_generation_1' + (idSuffix !== undefined ? '_' + idSuffix : '')}"></select>

    <label class="hidden" data-bind="text: translated('New generation'),
                      attr: {for: 'new_generation_1' + (idSuffix !== undefined ? '_' + idSuffix : '')}"></label>
    <select class="width_full" data-bind="css: {invalid_data: newGeneration1.isInvalid},
                       options: pyratFrontend.session.pyratConf.GEN_SETS.newgen,
                       optionsCaption: translated('None2'),
                       value: newGeneration1,
                       attr: {id: 'new_generation_1' + (idSuffix !== undefined ? '_' + idSuffix : '')}"></select>

    <!-- ko if: pyratFrontend.session.pyratConf.MULTIPLE_SUBGEN -->
    <label class="hidden" data-bind="text: translated('Sub generation'),
                      attr: {for: 'sub_generation_2' + (idSuffix !== undefined ? '_' + idSuffix : '')}"></label>
    <select class="width_full" data-bind="css: {invalid_data: subGeneration2.isInvalid},
                       options: pyratFrontend.session.pyratConf.GEN_SETS.subgen2,
                       optionsCaption: translated('None2'),
                       value: subGeneration2,
                       attr: {id: 'sub_generation_2' + (idSuffix !== undefined ? '_' + idSuffix : '')}"></select>


    <label class="hidden" data-bind="text: translated('New generation'),
                      attr: {for: 'new_generation_2' + (idSuffix !== undefined ? '_' + idSuffix : '')}"></label>
    <select class="width_full" data-bind="options: pyratFrontend.session.pyratConf.GEN_SETS.newgen2,
                       optionsCaption: translated('None2'),
                       value: newGeneration2,
                       attr: {id: 'new_generation_2' + (idSuffix !== undefined ? '_' + idSuffix : '')}"></select>
    <!-- /ko -->

    <!-- ko ifnot: pyratFrontend.session.pyratConf.MULTIPLE_SUBGEN -->
    <label class="hidden" data-bind="text: translated('Additional generation'),
                      attr: {for: 'additional_generation' + (idSuffix !== undefined ? '_' + idSuffix : '')}"></label>
    <select class="width_full" data-bind="options: pyratFrontend.session.pyratConf.GEN_SETS.addgen,
                       optionsCaption: translated('None2'),
                       value: additionalGeneration,
                       attr: {id: 'additional_generation' + (idSuffix !== undefined ? '_' + idSuffix : '')}"></select>
    <!-- /ko -->
</div>
`;
// Exports
export default code;